import { Stack, Text } from "basis";
import { ReactNode } from "react";

interface Props {
  header: string;
  testId?: string;
  children: ReactNode;
}

export const TextCell = ({ header, testId, children }: Props) => (
  <Stack gap="2">
    <Text>{header}</Text>
    <Text testId={testId}>
      <strong>{children}</strong>
    </Text>
  </Stack>
);
